import { render, staticRenderFns } from "./RecommendDoctorModal.vue?vue&type=template&id=90167584&scoped=true"
import script from "./RecommendDoctorModal.vue?vue&type=script&lang=js"
export * from "./RecommendDoctorModal.vue?vue&type=script&lang=js"
import style0 from "./RecommendDoctorModal.vue?vue&type=style&index=0&id=90167584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90167584",
  null
  
)

export default component.exports